export const BUTTON_STYLES = {
  primary: "primary",
  secondary: "secondary",
  tertiary: "tertiary",
  danger: "danger",
  danger_text: "danger-text",
  text: "text",
  link: "link",
};

export const SIZES = { small: "small", medium: "medium", large: "large" };

export const STRATEGY = { absolute: "absolute", fixed: "fixed" };

export const MENU_ITEM_TYPES = {
  menuItem: "menuItem",
  divider: "divider",
};

export const DEFAULT_TOOLTIP_PROPS = {
  disabled: true,
  position: "bottom",
  touch: ["hold", 500],
};
